"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var RULES = Symbol();
var VERSION = Symbol();
var UP = Symbol();

var Migration = /*#__PURE__*/function () {
  function Migration() {
    _classCallCheck(this, Migration);

    this[RULES] = {};
    this[VERSION] = 1;
  }

  _createClass(Migration, [{
    key: "version",
    get: function get() {
      return this[VERSION];
    }
  }, {
    key: "add",
    value: function add(_ref) {
      var targetVersion = _ref.targetVersion,
          migrate = _ref.migrate;

      if (targetVersion !== this[VERSION] + 1) {
        throw new RangeError("targetVersion must be ".concat(this[VERSION] + 1));
      }

      if (typeof migrate !== 'function') {
        throw new TypeError('migrate must be a function');
      }

      this[RULES][targetVersion] = migrate;
      this[VERSION]++;
    }
  }, {
    key: UP,
    value: function value(data, fromVersion) {
      var targetVersion = fromVersion + 1;
      var rule = this[RULES][targetVersion];
      return rule(data);
    }
  }, {
    key: "migrate",
    value: function migrate(_ref2) {
      var data = _ref2.data,
          version = _ref2.version;

      if (typeof version !== 'number') {
        throw new TypeError("version must be a number, currently it is ".concat(version));
      }

      if (version > this[VERSION]) {
        throw new RangeError("version must be <= ".concat(this[VERSION], ", currently it is ").concat(version));
      }

      var targetVersion = this[VERSION];
      var result, currentVersion;

      for (currentVersion = version, result = data; currentVersion < targetVersion; currentVersion++) {
        result = this[UP](result, currentVersion);
      }

      return {
        data: result,
        version: currentVersion
      };
    }
  }]);

  return Migration;
}();

exports.default = Migration;